export const LABELS = {
  TRACKING_NUMBER: $localize`Tracking Number`,
  SHIPPER_ACCOUNT: $localize`Shipper`,
  DECLARED_VALUE: $localize`Declared Value`,
  ADD_PACKAGE: $localize`Add a Package`,
  REMOVE_PACKAGE: $localize`Remove Package`,
  COD: $localize`COD`,
  INVALID_SHIPPER: $localize`! Invalid Shipper`,
};
